module.exports = __webpack_public_path__ + "static/media/cumulative-spend.2e5276cd.png";